import Box from '@mui/material/Box';
import { Trans } from "react-i18next";
import IndicatorsContext from './IndicatorsContext';
import VerifiedUser from '@mui/icons-material/VerifiedUserOutlined';
import Badge from '@mui/icons-material/BadgeOutlined';
import Assignment from '@mui/icons-material/AssignmentOutlined';
import Map from '@mui/icons-material/Map';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';

export default function () {
  const navigate = useNavigate();
  const overdueDocumentIcons = [
    (<VerifiedUser className="indicators-item-icon"/>),
    (<Badge className="indicators-item-icon"/>),
    (<Assignment className="indicators-item-icon"/>),
    (<Map className="indicators-item-icon"/>)
  ]

return (
  <IndicatorsContext.Consumer>
    {context => {
      return (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 3,
            fontFamily: "'Inter', sans-serif",
          }}
        >
          {/* Encabezado principal */}
          <Box
            sx={{
              backgroundColor: "#f9fafb",
              borderRadius: 3,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              p: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              transition:
                        "transform 0.15s ease, box-shadow 0.15s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                      },
            }}
            onClick={() => {
              navigate("/web/documentsVto");
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 600, color: "#103115" }}>
              <Trans i18nKey={`screens.indicators.overdueDocumentTitle`} />
            </Typography>
          </Box>

          {/* Grid de tarjetas */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)",
                sm: "repeat(3, 1fr)",
                md: "repeat(4, 1fr)",
                lg: "repeat(5, 1fr)",
              },
              gap: 3,
            }}
          >
            {context.indicators.overdueDocuments.map(
              (overdueDocument: any, index: number) => (
                <Box
                    key={index}
                    sx={{
                      backgroundColor: "#ffff",
                      color: "#103115",
                      borderRadius: 2,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      cursor: "pointer",
                      borderTop: "6px solid #D46A6A ",
                      borderLeft: "2px solid #ccc",
                      borderRight: "2px solid #ccc",
                      borderBottom: "2px solid #ccc",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 2,
                      minHeight: 130,
                      transition:
                        "transform 0.15s ease, box-shadow 0.15s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 6px 15px rgba(0,0,0,0.5)",
                      },
                    }}
                  onClick={() =>
                    navigate("/web/documentsVto", {
                      state: { filterDocumentType: overdueDocument.documentType },
                    })
                  }
                >
                  {/* Ícono */}
                  <Box
                    sx={{
                      mb: 2,
                      color: "#e53935",
                      fontSize: 55,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      filter: "drop-shadow(0 1px 1px rgba(229, 57, 53, 0.25))",
                    }}
                  >
                    {overdueDocumentIcons[index]}
                  </Box>

                  {/* Tipo de documento */}
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      color: "#103115",
                      textAlign: "center",
                      mb: 1,
                      textTransform: "capitalize",
                      letterSpacing: "0.02em",
                    }}
                  >
                    {overdueDocument.documentType}
                  </Typography>

                  {/* Conteo */}
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 700,
                      color: "#e53935",
                      letterSpacing: "-0.02em",
                    }}
                  >
                    {overdueDocument?.countUnit}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        </Box>
      );
    }}
  </IndicatorsContext.Consumer>
);

}